import PlayersList from "../../components/PlayersList";
import { useQuery, useApolloClient, useMutation } from "@apollo/client";
import { getAllPlayers, START_GAME_MUTATION } from "../../api/queries";
import useSharedArray from "../../hooks/useSharedArray";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import "./InitializeGame.scss";

const STATE = {
    HOME: "HOME",
    AWAY: "AWAY"
}

function InitializeGame() {
    const hasGame = false;
    const history = useHistory();

    const { loading, error, data } = useQuery(getAllPlayers, {
        onCompleted: (res) => {
            console.log("completed");
            setInitialState(res.getPlayers);
            console.log(remainingPlayers);
        }
    });

    const gameStarted = () => {
        console.log("game started");
        history.push("/game");
    }

    const [createGame] = useMutation(START_GAME_MUTATION, {
        onCompleted: gameStarted
    })
    const {remainingPlayers, setInitialState, updateArrayState } = useSharedArray([]);

    const [ homePlayers, setHomePlayers] = useState([]);
    const [ awayPlayers, setAwayPlayers] = useState([]);

    const updatePlayers = (players, state) => {
        updateArrayState(players);
        switch (state) {
            case STATE.HOME:
                setHomePlayers(players);
                break;
            case STATE.AWAY:
                setAwayPlayers(players);
                break;                       
        }
    }

    if (loading) return <p>Loading...</p>;

    const startGame = () => {
        console.log("start game");
        console.log(remainingPlayers);
        const mapIds = (p) => { return {id: p.id, name: p.name} };

        const game = {
            home: homePlayers.map(mapIds),
            away: awayPlayers.map(mapIds)
        }
        console.log(game);
        createGame({
            variables: {
                tenant: 1,
                game: game
            }
        });
    }

    return (
        <div className="initialize-game-container">
            <PlayersList players={remainingPlayers} name={STATE.HOME} updateRemaining={updatePlayers}></PlayersList>
            <PlayersList players={remainingPlayers} name={STATE.AWAY} updateRemaining={updatePlayers}></PlayersList>
            <button onClick={() => startGame()}>Start Game</button>
        </div>
    )
}

export default InitializeGame;